export const CustomerType = {
  Unknown: 'Unknown',
  Private: 'Private',
  Business: 'Business',
};

export const backgroundType = {
  Unkown: 'Unkown',
  Private: 'Private',
  Business: 'Business',
  //
};
